<template>
  <div class="css-grid sales-report__stats">
    <StatsRevenuePerEmployee></StatsRevenuePerEmployee>
    <StatsUnitsPerEmployee></StatsUnitsPerEmployee>
    <StatsAsp></StatsAsp>
    <div class="sales-report__stats-disclaimer">* National Averages calculated from Fuel Members across the United States</div>
  </div>
</template>

<script>
  import StatsRevenuePerEmployee from './StatsRevenuePerEmployee.vue';
  import StatsUnitsPerEmployee from './StatsUnitsPerEmployee.vue';
  import StatsAsp from './StatsAsp.vue';

  export default {
    name: 'ReportStats',
    components: {
      StatsRevenuePerEmployee,
      StatsUnitsPerEmployee,
      StatsAsp,
    },
  };
</script>
